import PropTypes from 'prop-types';

/* PropTypes */

export const DatePickerFieldPropTypes = {
  action: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
    PropTypes.node,
  ]),
  auth: PropTypes.bool,
  className: PropTypes.string,
  dateOnly: PropTypes.bool,
  error: PropTypes.string,
  fieldClassName: PropTypes.string,
  flash: PropTypes.bool,
  invisible: PropTypes.bool,
  label: PropTypes.string,
  monthOnly: PropTypes.bool,
  multiline: PropTypes.bool,
  onKeyPress: PropTypes.func,
  required: PropTypes.bool,
  rounded: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
};

/* Default Props */

export const DatePickerFieldDefaultProps = {
  action: null,
  auth: false,
  className: null,
  dateOnly: null,
  error: null,
  fieldClassName: null,
  flash: false,
  invisible: false,
  label: null,
  monthOnly: null,
  onKeyPress: () => {},
  required: null,
  rounded: false,
  value: null,
};
